import {getAllProperties} from "../service/PropertyService";
import React, {useEffect, useState} from "react";
import {Col, Container, FormControl, Row} from "react-bootstrap";
import DataTable from "react-data-table-component";
import PropertyExpand from "./PropertyExpand";
import PropertyJobsModal from "./PropertyJobsModal";

const customStyles = {
    rows: {
        style: {
            minHeight: '32px', // override the row height
        },
    },
};
export default function ManageProperty() {

    const [tableData, setTableData] = useState([])
    const [filteredData, setFilteredData] = useState([])
    const [searchText, setSearchText] = useState("")
    const [selectedProperty, setSelectedProperty] = useState(null);
    const [showJobsModal, setShowJobsModal] = useState(false);

    const handleJobsModalClose = () => setShowJobsModal(false);
    const handleRowClick = (row) => {
        setSelectedProperty(row);
        setShowJobsModal(true);
    };


    const columns = [{
        name: 'Property Id', selector: row => row.property_id, sortable: true,
        width: '120px',
    }, {
        name: 'Full Address', selector: row => row.full_address, sortable: true,
        width: '400px',
    }, {
        name: 'Name', selector: row => row.cos_customer_name, sortable: true,
    },

        {
            name: 'Agent Name', selector: row => row.agent_name, sortable: true,
        }, {
            name: 'Phone', selector: row => row.phone, sortable: true,
        }, {
            name: 'email', selector: row => row.email, sortable: true,
        }, {
            name: 'region', selector: row => row.region, sortable: true,
        }, {
            cell: row => <PropertyExpand property={row}/>,
            allowoverflow: true,
            button: "true",
            width: '300px',
        }];

    useEffect(() => {
        refreshProperties();
    }, []);

    function filterSearchText(value) {
        setSearchText(value)
        // setRoleFilterSelection
        filterTables(tableData, value)

    }

    function filterTables(rawdata, searchText) {
        let tempData = rawdata
        //cos_customer_name, username, agent_name, phone, email
        if (searchText && searchText.length > 0) {
            tempData = tempData.filter(item => (item.full_address && item.full_address.toLowerCase().includes(searchText.toLowerCase()) || (item.agent_name && item.agent_name.toLowerCase().includes(searchText.toLowerCase())) || (item.cos_customer_name && item.cos_customer_name.toLowerCase().includes(searchText.toLowerCase())) || (item.phone && item.phone.toLowerCase().includes(searchText.toLowerCase())) || (item.email && item.email.toLowerCase().includes(searchText.toLowerCase()))));
        }
        setTableData(rawdata)
        setFilteredData(tempData)
    }

    function refreshProperties() {
        getAllProperties().then(response => {
            if (response.status === 200) {
                response.json().then(result => filterTables(result, searchText))
            } else {
                response.text().then(result => console.log(result))
            }
        }).catch(error => console.log('error', error));
    }


    return (<Container fluid>
        <Row>
            <Col sm={3} style={{textAlign: "right"}}>

                <FormControl style={{height: "22px"}}
                             value={searchText}
                             onChange={(e) => filterSearchText(e.target.value)}
                             type="search"
                             placeholder="Search Property Address"
                             className="mr-2"
                             aria-label="Search"
                />
            </Col>
        </Row>
        <Row>
            <DataTable
                columns={columns}
                data={filteredData}
                // expandableRows
                // expandableRowsComponent={PropertyExpand}
                customStyles={customStyles}
                pagination
                highlightOnHover
                pointerOnHover
                onRowClicked={handleRowClick}
            />
        </Row>
        
        {selectedProperty && (
            <PropertyJobsModal 
                show={showJobsModal} 
                handleClose={handleJobsModalClose} 
                property={selectedProperty} 
            />
        )}

    </Container>)
}
